import Vuex from 'vuex'

export default {
  install: (app) => {
    app.use(Vuex)

    const { store } = require('./index')
    
    const userString = localStorage.getItem('user')
    if (userString) {
      const userData = JSON.parse(userString)
      store.commit('SET_USER_DATA', {
        user: userData
      })
    }

    app.mixin({
      computed: {
        $user: {
          get () {
            return store.getters.user
          }
        }
      }
    })
    
    app.prototype.$store = store
  }
}